import React, { useState, useRef, useEffect } from 'react';
import {ListGroup, Form} from 'react-bootstrap';

export interface ListOption {
  id: string | number;
  label: string;
}

interface OptionListProps {
  title: string;
  options: ListOption[];
  selectedId?: string | number | null;
  onChange?: (selectedId: string | number | null) => void;
}

const OptionList: React.FC<OptionListProps> = ({ 
  title, 
  options, 
  selectedId, 
  onChange 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  // Input validation
  // const [invalidInput, setInvalidInput] = useState(false);
  const MAX_CHARACTERS = 30;
  const englishCharRegex = /^[a-zA-Z\s',.!-]*$/;

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleClick = () => {
    setIsEditing(true);
    // setInvalidInput(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    // setInvalidInput(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Check if input contains invalid characters
    if (!englishCharRegex.test(inputValue)) {
      // setInvalidInput(true);
      // Remove non-English characters and numbers
      const cleanedValue = inputValue.replace(/[^a-zA-Z\s',.!-]/g, '');
      setContent(cleanedValue.slice(0, MAX_CHARACTERS));
      return;
    }
    
    // setInvalidInput(false);
    setContent(inputValue.slice(0, MAX_CHARACTERS));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent number input from number keys
    if (e.key >= '0' && e.key <= '9') {
      e.preventDefault();
      return;
    }

    if (e.key === 'Enter') {
      handleBlur();
    }
  };

  const handleSelect = (id: string | number) => {
    if (onChange && id !== selectedId) {
      onChange(id);
    }
  };

  return (
    <>
      <h4>{title}</h4>
      <ListGroup>
        {options.map((option) => (
          <>
          { option.label === "**User Input**" ? (
            <ListGroup.Item 
              action 
              active={option.id === selectedId}
              onClick={() => {handleClick(); handleSelect(option.id)}}
              style={{ cursor: 'pointer' }}
            >
              <Form.Control
                ref={inputRef}
                value={content}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                placeholder='Write a candidate name'
                maxLength={MAX_CHARACTERS}
                style={{
                  border: 'none',
                  padding: 0,
                  background: 'transparent',
                  color: option.id === selectedId ? 'white' : 'black'
                }}
              />
            </ListGroup.Item>
          ) : (
            <ListGroup.Item
              key={option.id}
              action
              active={option.id === selectedId}
              onClick={() => handleSelect(option.id)}
              style={{ cursor: 'pointer' }}
            >
              {option.label}
            </ListGroup.Item>
          )}
          </>
        ))}
      </ListGroup>
    </>
  );
};

export default OptionList;